/**
 * Status-Optionen des Konto-Menüs (Untermenü „Status setzen“). Die Zustände sind der Vertrag mit der
 * bestehenden Status-Logik (`user_status.state`, Server-Action setStatusAction); die Shell kennt nur die
 * Anzeige. Punkte nach dem Block ui-components/…/account-menu-with-status-controls (grün/rot/gelb, Zeile
 * „Out of office“ mit Kalender-Symbol), aber nur aus Theme-Tokens: `bg-status-ok` (Verfügbar), `bg-destructive`
 * (Beschäftigt, Nicht stören), `bg-status-warn` (Abwesend), `bg-primary` (Fokus). Die Roh-Palettenfarben des Blocks
 * (`bg-yellow-500` nur 1,91:1 auf Weiß) entfallen, jeder Punkt hat ≥ 3:1 (Nacharbeit MP1, A6-Prüfung).
 *
 * Klassen stehen als feste, vollständige Ketten (keine zusammengesetzten Namen): `punktMittel` für den
 * Punkt im Untermenü (size-2.5), `punktKlein` für den Punkt neben dem Wert (size-2) und `punktRing` am Bild.
 */
export const STATUS_ZUSTAENDE = ["available", "busy", "focus", "away", "dnd", "vacation"] as const;
export type StatusZustand = (typeof STATUS_ZUSTAENDE)[number];

export interface StatusOption {
  zustand: StatusZustand;
  label: string;
  /** Punkt im Untermenü; null = Kalender-Symbol (Urlaub). */
  punktMittel: string | null;
  /** Punkt neben dem Wert in der Auslöserzeile. */
  punktKlein: string;
  /** Punkt am Profilbild (Statusring). */
  punktRing: string;
}

export const STATUS_OPTIONEN: readonly StatusOption[] = [
  { zustand: "available", label: "Verfügbar", punktMittel: "block size-2.5 rounded-full bg-status-ok", punktKlein: "block size-2 rounded-full bg-status-ok", punktRing: "block size-2.5 rounded-full bg-status-ok" },
  { zustand: "busy", label: "Beschäftigt", punktMittel: "block size-2.5 rounded-full bg-destructive", punktKlein: "block size-2 rounded-full bg-destructive", punktRing: "block size-2.5 rounded-full bg-destructive" },
  { zustand: "focus", label: "Fokus", punktMittel: "block size-2.5 rounded-full bg-primary", punktKlein: "block size-2 rounded-full bg-primary", punktRing: "block size-2.5 rounded-full bg-primary" },
  { zustand: "away", label: "Abwesend", punktMittel: "block size-2.5 rounded-full bg-status-warn", punktKlein: "block size-2 rounded-full bg-status-warn", punktRing: "block size-2.5 rounded-full bg-status-warn" },
  { zustand: "dnd", label: "Nicht stören", punktMittel: "block size-2.5 rounded-full bg-destructive", punktKlein: "block size-2 rounded-full bg-destructive", punktRing: "block size-2.5 rounded-full bg-destructive" },
  { zustand: "vacation", label: "Urlaub", punktMittel: null, punktKlein: "block size-2 rounded-full bg-muted-foreground-2", punktRing: "block size-2.5 rounded-full bg-muted-foreground-2" },
];

export function statusOption(zustand: StatusZustand): StatusOption {
  return STATUS_OPTIONEN.find((o) => o.zustand === zustand) ?? STATUS_OPTIONEN[0]!;
}

/** Aktueller, freiwillig gesetzter Status der Person (nie aus Aktivität abgeleitet, Betriebsrat). */
export interface KontoStatus {
  zustand: StatusZustand;
  nachricht?: string | null;
}
